if (!customElements.get('nz-market-welcome')) {
  class NzMarketWelcome extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return
      this.initialized = true

      this.dialog = this.querySelector('[role="dialog"]')
      this.closeButtons = this.querySelectorAll('[data-nz-welcome-close]')
      this.previouslyFocusedElement = null

      this.closeButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          if (
            event.currentTarget.classList.contains('nz-market-welcome__backdrop') &&
            this.dataset.closeOnOverlay !== 'true'
          ) {
            return
          }
          this.close()
        })
      })

      this.addEventListener('keydown', this.handleKeydown.bind(this))

      if (this.dataset.designMode === 'true') {
        this.show()
        return
      }

      if (!this.wasDismissed()) {
        window.setTimeout(() => this.show(), Number(this.dataset.delay) || 0)
      }
    }

    wasDismissed() {
      const dismissDays = Number(this.dataset.dismissDays) || 0
      if (dismissDays <= 0) return false

      try {
        const dismissedAt = Number(window.localStorage.getItem(this.dataset.storageKey))
        return dismissedAt > 0 && Date.now() - dismissedAt < dismissDays * 86400000
      } catch (error) {
        return false
      }
    }

    show() {
      if (!this.hidden) return

      this.previouslyFocusedElement = document.activeElement
      this.hidden = false
      document.body.classList.add('nz-market-welcome-open')
      window.requestAnimationFrame(() => {
        this.classList.add('is-visible')
        this.dialog.focus({ preventScroll: true })
      })
    }

    close() {
      if (this.hidden) return

      if (this.dataset.designMode !== 'true') {
        try {
          window.localStorage.setItem(this.dataset.storageKey, String(Date.now()))
        } catch (error) {
          // The popup still closes when storage is unavailable.
        }
      }

      this.classList.remove('is-visible')
      document.body.classList.remove('nz-market-welcome-open')
      window.setTimeout(() => {
        this.hidden = true
        if (this.previouslyFocusedElement?.focus) this.previouslyFocusedElement.focus()
      }, 280)
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault()
        this.close()
        return
      }

      if (event.key !== 'Tab') return

      const focusableElements = Array.from(
        this.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((element) => element.offsetParent !== null)

      if (focusableElements.length === 0) {
        event.preventDefault()
        this.dialog.focus()
        return
      }

      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault()
        lastElement.focus()
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault()
        firstElement.focus()
      }
    }
  }

  customElements.define('nz-market-welcome', NzMarketWelcome)
}
